import { styled } from 'stitches.config'

export const HeroRoot = styled('div', {
  padding: '10px 0px 80px',

    '& .d-only': {
    display: 'none',
  },
  '& .m-only': {
    display: 'block',
  },

  '@bp2': {
    padding: '64px',
    '& .d-only': {
      display: 'block',
    },
    '& .m-only': {
      display: 'none',
    },
  },
})

export const HeroFlex = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  margin: 'auto',

  '@bp2': {
    flexDirection: 'row',
    maxWidth: '1292px',
    gap: '60px'
  },
})

export const CopyColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  paddingRight: '$2',
  width: '100%',
  padding: '0px 16px 64px',

  '@bp2': {
    width: '51%',
    padding: 0,
  },
})

export const ImageColumn = styled('div', {
  width: '100%',
  lineHeight: 0,
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '40px',

  '@bp2': {
    width: '49%',
  },
})

export const Title = styled('h1', {
  fontSize: '$h2',
  letterSpacing: '$h2',
  lineHeight: '$h2',

  '@bp2': {
    fontSize: '$h1',
    letterSpacing: '$h1',
    lineHeight: '$h1',
  },
})

export const AddToCartContainer = styled('div', {
  width: '100%',
  marginTop: '20px',
  '& input.fd-box-quantity': {
    width: '99px',
    height: '56px',
    outline: 'none',
    borderRadius: '4px',
    padding: '16px',
    fontSize: '$body',
    letterSpacing: '$body',
    lineHeight: '$body',
    border: '1px solid $accent-gray',
    color: '$tertiary-1000',
    transition: '0.1s color ease-in-out, 0.3s border ease-in-out',
  },

  '& input.fd-box-quantity:focus': {
    border: '1px solid $accent-black',
    color: '$accent-black',
  },
})

export const ImageContainer = styled('div', {
  aspectRatio: 393 / 383,
  width: '100%',

  '@bp2': {
    aspectRatio: 597 / 621,
    maxWidth: '597px',
  },
})

export const RadioWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  gap: '$3',
  marginTop: '$2',
  width: '100%',
})
export const RecipesContainer = styled('div', {
  marginTop: '32px',
  width: '100%',
})

export const RecipeOption = styled('div', {
  width: '100%',
  maxWidth: '195px',
  height: '64px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  border: '1px solid $accent-gray',
  background: '$accent-white',
  transition: 'border 0.3s ease-in-out, background 0.3s ease-in-out',
  borderRadius: '$pill',
  fontSize: '$body',
  letterSpacing: '$body',
  lineHeight: '$body',
  fontWeight: '$regular',

  '@bp2': {
    maxWidth: '195px',
  },

  '&:hover': {
    border: '1px solid $primary-500',
    background: '$tertiary-200',
  },

  variants: {
    isActive: {
      true: {
        border: '1px solid $primary-500',
        background: '$tertiary-200',
      },
    },
  },
})

export const ExtraInformation = styled('div', {
  width: '100%',


})

export const TableWrapper = styled('table', {
  paddingBottom: '$2',
  borderCollapse: 'collapse',

  '& th': {
    fontSize: '$headline',
    lineHeight: '$headline',
    fontWeight: '$medium',
    letterSpacing: '$body',
    verticalAlign: 'bottom',
    paddingBottom: '6px',
  },
  '& thead': {
    borderBottom: '1px solid $accent-black',
  },
  '& tbody tr:first-child td': {
    paddingTop: '12px',
  },
  '& tbody': {
    paddingBottom: '4px',
  },
  '& th:nth-child(1)': {
    width: '40%',
  },
  '& th:nth-child(2)': {
    width: '60%',
  },
  '& td': {
    fontSize: '$body',
    lineHeight: '$body',
    letterSpacing: '$body',
    padding: '4px',
  },
})

export const TableRoot = styled('div', {
  background: '$tertiary-200',
  paddingBottom: '16px',
  padding: '32px 16px 16px',
  marginTop: '$2',
  maxWidth: '576px',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',

  '@bp2': {
    padding: '40px 40px 16px',
  }
})

export const AdditionalInfo = styled('div', {
  width: '100%',
  textAlign: 'right',
})
